module.exports = __webpack_public_path__ + "eb542d24d6d2fd6c4d82944c3eea4a93.png";


//////////////////
// WEBPACK FOOTER
// ./components/applications/success/ads/lemonade/lemonade-img.png
// module id = 1119
// module chunks = 0